(function () {
  if (window.__mvColorImageCardsReady) {
    return;
  }

  window.__mvColorImageCardsReady = true;

  function parseImageGroup(swatch) {
    if (!swatch) {
      return [];
    }

    try {
      var group = JSON.parse(swatch.getAttribute('data-image-group') || '[]');

      return Array.isArray(group) ? group.filter(function (image) {
        return image && image.src;
      }) : [];
    } catch (error) {
      return [];
    }
  }

  function updateCardImage(card) {
    var image = card.querySelector('[data-mv-card-image]');
    var group = card._mvImageGroup || [];
    var imageData = group[card._mvImageIndex || 0];

    if (!image || !imageData || !imageData.src) {
      return;
    }

    image.src = imageData.src;

    if (imageData.srcset) {
      image.srcset = imageData.srcset;
    } else {
      image.removeAttribute('srcset');
    }

    if (imageData.alt) {
      image.alt = imageData.alt;
    }
  }

  function preloadHoverImage(card) {
    var group = card._mvImageGroup || [];

    if (group.length < 2 || !group[1].src) {
      card._mvHoverPreload = null;
      return;
    }

    var currentImage = card.querySelector('[data-mv-card-image]');
    var preload = new Image();

    if (group[1].srcset) {
      if (currentImage && currentImage.sizes) {
        preload.sizes = currentImage.sizes;
      }

      preload.srcset = group[1].srcset;
    }

    preload.src = group[1].src;
    card._mvHoverPreload = preload;
  }

  function setActiveSwatch(card, swatch) {
    card.querySelectorAll('[data-mv-color-swatch]').forEach(function (item) {
      var isActive = item === swatch;

      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function selectCardSwatch(card, swatch) {
    var variantId = swatch.getAttribute('data-variant-id');
    var variantUrl = swatch.getAttribute('data-variant-url');
    var variantInput = card.querySelector('input[name="id"]');

    card._mvImageGroup = parseImageGroup(swatch);
    card._mvImageIndex = 0;
    card.dataset.mvSelectedColor = swatch.getAttribute('data-color') || '';

    if (variantUrl) {
      card.querySelectorAll('[data-mv-card-product-link]').forEach(function (link) {
        link.href = variantUrl;
      });
    }

    if (variantId && variantInput) {
      variantInput.value = variantId;
    }

    setActiveSwatch(card, swatch);
    updateCardImage(card);
    preloadHoverImage(card);
  }

  function setCardHoverImage(card, isHovered) {
    var group = card._mvImageGroup || [];

    card._mvImageIndex = isHovered && group.length > 1 ? 1 : 0;
    updateCardImage(card);
  }

  function initCard(card) {
    if (card.dataset.mvColorImageReady === 'true') {
      return;
    }

    card.dataset.mvColorImageReady = 'true';

    var activeSwatch = card.querySelector('[data-mv-color-swatch].is-active') || card.querySelector('[data-mv-color-swatch]');

    if (activeSwatch) {
      selectCardSwatch(card, activeSwatch);
    }
  }

  function initCards(scope) {
    if (!scope || !scope.querySelectorAll) {
      return;
    }

    scope.querySelectorAll('[data-mv-color-image-card]').forEach(initCard);
  }

  function hoverIsAvailable() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target && event.target.closest
      ? event.target.closest('[data-mv-color-swatch]')
      : null;

    if (!swatch) {
      return;
    }

    var card = swatch.closest('[data-mv-color-image-card]');

    if (!card) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    selectCardSwatch(card, swatch);
  });

  document.addEventListener('mouseover', function (event) {
    if (!hoverIsAvailable()) {
      return;
    }

    var media = event.target && event.target.closest
      ? event.target.closest('[data-mv-card-media]')
      : null;

    if (!media || event.relatedTarget && media.contains(event.relatedTarget)) {
      return;
    }

    var card = media.closest('[data-mv-color-image-card]');

    if (card) {
      setCardHoverImage(card, true);
    }
  });

  document.addEventListener('mouseout', function (event) {
    if (!hoverIsAvailable()) {
      return;
    }

    var media = event.target && event.target.closest
      ? event.target.closest('[data-mv-card-media]')
      : null;

    if (!media || event.relatedTarget && media.contains(event.relatedTarget)) {
      return;
    }

    var card = media.closest('[data-mv-color-image-card]');

    if (card) {
      setCardHoverImage(card, false);
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCards(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCards(document);
    });
  } else {
    initCards(document);
  }
})();
